<div class="main">
    <div class="dx-field-title">
        {{ fileTransfer.name ?? ('fileTransfer.pageTitle' | translate) }}<span style="color:red;">{{ fileTransfer.isDisabled ? (' (' + ('fileTransfers.lblIsDisabled' | translate | uppercase) + ')') : '' }}</span>
    </div>
    <dx-tab-panel #tabs
                  style="height: calc(100vh - 165px);"
                  iconPosition="start"
                  stylingMode="secondary"
                  [selectedIndex]="0"
                  [animationEnabled]="true">
        <dxi-item [title]="'_commons.flow' | translate" icon="fas fa-exchange-alt" style="padding:16px;">
            <app-file-transfer-form #fileTransferTab style="height:100%;" [environmentId]="currentEnvironmentId" [fileTransfer]="fileTransfer" />
        </dxi-item>
        <dxi-item [title]="'_commons.renaming' | translate" icon="fas fa-sync-alt" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-renaming-parameters #fileTransferRenamingTab style="height:100%;" />
        </dxi-item>
        <dxi-item [title]="'_commons.alerts' | translate" icon="far fa-bell" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-alerts #fileTransferAlertsTab style="height:100%;" />
        </dxi-item>
        <dxi-item [title]="'_commons.apiKeys' | translate" icon="fas fa-key" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-api-keys #fileTransferApiKeysTab style="height:100%;" />
        </dxi-item>
        <dxi-item [title]="'_commons.logs' | translate" icon="fas fa-terminal" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-logs #fileTransferLogsTab style="height:100%;" />
        </dxi-item>
        <dxi-item [title]="'_commons.onDemandExecutions' | translate" icon="fas fa-terminal" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-ondemand-executions #onDemandExecutionsTab style="height:100%;" />
        </dxi-item>
        <dxi-item [title]="'home.lblStatistics' | translate" icon="fas fa-terminal" style="padding:16px;" [visible]="fileTransfer.id">
            <app-file-transfer-statistics #statisticsTab style="height:100%;" [fileTransferName]="fileTransfer.name" />
        </dxi-item>
    </dx-tab-panel>
</div>